export default class PaymentCycleManagementColumnModel {
	static PaymentCycleManagementColumn = [
	  {
		  title: 'Payment Term',
		  align: 'left',
		  field: 'paymentCycleName'
	  }
	]
}
